export const getFieldColor = (stateStandard, stateValue, standard) => {
  return stateStandard === 'NotSpecified' || stateValue === undefined
    ? 'grey'
    : stateStandard === standard
    ? 'blue.500'
    : 'orange.500';
};
